// ------------------------------------
// props 輸入需求 :
// props.isON : boolean                                   ( 元件開關 )
// props.setReturnState : function( params : str )        ( 回傳 : str ('level 1', 'level 2', 'level 3') )
// ------------------------------------

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Account from '../../../../actions/Account';

const DayToNight = (props) => {
  const { t } = useTranslation(); // 1.2 i18n

  const [stateOpen, setStateOpen] = useState();
  function toggleStateOpen() {
    setStateOpen(!stateOpen);
  }
  const shift_show = props.daySwitch === 'all' ? t('HISTORY_RECORD.PERIOD') : props.daySwitch === 'day' ? t('HISTORY_RECORD.PERIOD_DAY') : t('HISTORY_RECORD.PERIOD_NIGHT');
  function clickState(e) {
    props.setDaySwitch(e.target.id);
  }
  return (
    <div className="col-4 fx-ccc ">
      <div className="top-tag fx-d-r mar-l">
        <div className="name fx-ccc">{t('HISTORY_RECORD.TWO_SHIFT')}</div>
        <div className="body h-50">
          <div className="inner st" onClick={toggleStateOpen}>
            {shift_show}
          </div>
          {stateOpen && (
            <div className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def" onClick={toggleStateOpen}>
              <div className="pos-a state">
                <div id="all" className="individual" onClick={clickState}>
                  {t('HISTORY_RECORD.PERIOD')}
                </div>
                <div id="day" className="individual" onClick={clickState}>
                  {t('HISTORY_RECORD.PERIOD_DAY')}
                </div>
                <div id="night" className="individual" onClick={clickState}>
                  {t('HISTORY_RECORD.PERIOD_NIGHT')}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DayToNight;
